import React from 'react';
import Modal from '@cp/src/components/Modal/Modal';
import { Typography } from '@navi/web-ui/lib/primitives';
import { Button } from '@navi/web-ui/lib/primitives';
import ClockLockIcon from '@cp/src/assets/icons/ClockLockIcon';
import { operativeHoursText } from './const';

interface OperativeHoursModalProps {
  visible: boolean;
  onClose: () => void;
}

const OperativeHoursModal: React.FC<OperativeHoursModalProps> = ({ visible, onClose }) => {
  return (
    <Modal
      visible={visible}
      onClose={onClose}
      showCloseIcon={false}
      isHeaderRequired={false}
      closeOnOutsideClick={false}
      contentWrapperClass="w-[400px]"
      contentClassName="p-0"
      overlappingIcon={<ClockLockIcon />}
    >
      <div className="flex flex-col items-center pt-12">
        <Typography variant="h3" className="mb-4">
          {operativeHoursText.header}
        </Typography>
      </div>
      <div className="flex justify-end">
        <Button variant="primary" onClick={onClose} className="w-[156px] h-9">
          Understood
        </Button>
      </div>
    </Modal>
  );
};

export default OperativeHoursModal;
